import { Component, Input, OnDestroy, EventEmitter, OnInit, HostListener, OnChanges, SimpleChanges, Output } from '@angular/core';
import { MdDialogRef } from '@angular/material';

import { ProductService } from 'app/services/products/product.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';

@Component({
  selector: 'ota-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit, OnDestroy, OnChanges {
  @Input('disbledClose') isDisbledClose: boolean = false;
  @Input('closeBottom') closeBottom: boolean = false;
  @Input('fullscreen') isFullscreen: boolean;
  @Input('mobileFullscreen') isMobileFullscreen: boolean;
  @Input() heightRowButton: number = 0;
  @Input('class') class: string = '';
  @Input('title') title: String;
  @Input('subTitle') subTitle: String;
  @Input('rating') rating: Number;
  @Input('address') address: String;
  @Input('disbledClickBackground') isDisbledBackground: boolean = false;
  @Input('mice') isMice: boolean = false;
  @Input('closeAction') closeAction: (res: any) => {};
  @Input('closeType') closeType: string = '';
  @Output('eventEmitter')eventEmitter: EventEmitter<any> = new EventEmitter();
  constructor(
    private utilitiesService: UtilitiesService,
    private productService: ProductService,
    private dialogRef: MdDialogRef<DialogComponent>,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isMobileFullscreen) {
      this.updateHeightMobileScreen();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.updateHeightMobileScreen();
  }

  ngOnInit() {
    this.updateHeightMobileScreen();
    setTimeout(() => {
      if (this.isMice) {
        this.utilitiesService.lockBody(false);
      } else {
        this.utilitiesService.lockBody();
      }
      this.utilitiesService.lockBodyBackdrop();
    });
  }

  updateHeightMobileScreen() {
    if (this.isMobileFullscreen) {
      document.documentElement.style.setProperty(`--dialog-vh`, `${window.innerHeight * 0.01}px`);
      document.documentElement.style.setProperty(`--heightRowButton`, `${this.heightRowButton}px`);
    }
  }

  ngOnDestroy() {
    this.utilitiesService.unlockBody();
    this.utilitiesService.unlockBodyBackdrop();
  }

  onClose() {
    this.dialogRef.close();
  }

  onChoose(){
    this.eventEmitter.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog/dialog.component.ts